// 上传 purpose → 展示比例（前端真值；2026-09-18 首页 Banner/专区封面比例收口）
//
// 与服务端镜像：server/config/imagePurposes.js（上传校验真值）——
// server/test/upload_purpose_ratio_test.js 读取本文件强制两侧一致，改比例必须两边同步改。
//
// ratioLabel 同时驱动 ImageUploader 的预览框比例与裁剪框比例锁（单一来源，
// 管理页不再手写 ratio prop / 手写比例文案）；hint 供管理页提示文案直接引用。
// 真值来源 = 前台最终视觉 CSS：home_banner 3.4:1（Carousel.vue）、hub_cover 16:9（HubPage.vue）。
export const IMAGE_PURPOSES = {
  home_banner: { ratioLabel: '3.4:1', hint: '建议上传 3.4:1 横图（如 1700×500）' },
  hub_cover: { ratioLabel: '16:9', hint: '建议上传 16:9 横图（如 1280×720）' }
}
